import React from 'react';
import LegalLayout from './LegalLayout';

const Disclaimer = () => {
    return (
        <LegalLayout title="Disclaimer" lastUpdated="30th Jan 2026">
            <p>The information and services provided by Trend Ads at trendads.ai are for general informational and platform-use purposes only.</p>

            <h2>1) No professional advice</h2>
            <p>Nothing on the Service constitutes legal, financial, investment, tax, or other professional advice. You should consult qualified professionals before making decisions.</p>

            <h2>2) Advertising and third-party content</h2>
            <p>The Service may display ads, offers, and links from third parties. We do not endorse, guarantee, or assume responsibility for third-party products, services, claims, or content. Any interactions you have with advertisers are between you and them.</p>

            <h2>3) Rewards and digital assets (if applicable)</h2>
            <p>If the Service offers rewards or involves blockchain-based assets:</p>
            <ul>
                <li>Digital assets and blockchain technology carry risk (volatility, network fees, irreversible transactions).</li>
                <li>We do not guarantee the availability, value, timing, or amount of rewards.</li>
                <li>Eligibility checks and anti-fraud protections may affect reward issuance.</li>
            </ul>

            <h2>4) AI and automated systems</h2>
            <p>We may use AI/automation for optimization, recommendations, moderation, or analytics. Outputs may be inaccurate, incomplete, or unsuitable for your needs. You are responsible for verifying results and ensuring compliance with applicable laws and platform policies.</p>

            <h2>5) Availability and warranties</h2>
            <p>The Service is provided “as is” and “as available.” We do not warrant uninterrupted operation, error-free performance, or that defects will be corrected.</p>

            <h2>6) Limitation of liability</h2>
            <p>To the maximum extent permitted by law, Trend Ads will not be liable for losses or damages arising from your use of (or inability to use) the Service, including indirect or consequential losses.</p>

            <h2>7) Contact</h2>
            <p>For questions about this Disclaimer, contact us via email at support@trendcreator.io</p>
        </LegalLayout>
    );
};

export default Disclaimer;
